export const DEFAULT_GROQ_CHAT_MODEL = 'openai/gpt-oss-120b';
